export function normalizeClinicalStudies(rawStudies) {
  if (!Array.isArray(rawStudies)) return [];

  const byFolder = new Map();

  const toSafeName = (value) => (typeof value === "string" ? value.trim() : "");

  const scoreStudy = (study) => {
    let score = 0;
    if (study.product_name && study.product_name !== study.study_folder_name) score += 3;
    if (study.company_name) score += 1;
    if (study.product_descrp) score += 1;
    if (study.total_journals !== "—") score += 2;
    if (Array.isArray(study.search_terms) && study.search_terms.length > 0) score += 2;
    if (study.type === "Drug") score += 1;
    return score;
  };

  const upsertStudy = (study) => {
    const key = toSafeName(study.study_folder_name);
    if (!key) return;

    // Ignore placeholder rows like "0" when they carry no data.
    if (
      key === "0" &&
      !study.company_name &&
      !study.product_descrp &&
      study.total_journals === "—" &&
      (!Array.isArray(study.search_terms) || study.search_terms.length === 0)
    ) {
      return;
    }

    const existing = byFolder.get(key);
    if (!existing) {
      byFolder.set(key, study);
      return;
    }

    byFolder.set(
      key,
      scoreStudy(study) >= scoreStudy(existing) ? study : existing,
    );
  };

  for (const item of rawStudies) {
    if (typeof item === "string") {
      const studyName = toSafeName(item);
      if (!studyName) continue;

      upsertStudy({
        product_name: studyName,
        study_folder_name: studyName,
        folder: studyName,
        company_name: "",
        product_descrp: "",
        settings: {},
        metrics: {},
        type: "Device",
        total_journals: "—",
        search_terms: [],
      });
      continue;
    }

    if (!item || typeof item !== "object" || Array.isArray(item)) continue;

    let studyFolderName = item.study_folder_name;
    let payload = item;

    if (!studyFolderName) {
      const firstKey = Object.keys(item)[0];
      if (!firstKey) continue;
      studyFolderName = firstKey;
      payload = item[firstKey] || {};
    }

    const normalizedFolderName = toSafeName(studyFolderName);
    if (!normalizedFolderName) continue;

    const settings = payload?.settings || {};
    const metrics = payload?.metrics || {};
    const productName = toSafeName(settings.product_name) || normalizedFolderName;
    const perTerm = metrics?.Per_Term_Metrics || {};

    upsertStudy({
      product_name: productName,
      study_folder_name: normalizedFolderName,
      folder: normalizedFolderName,
      company_name: settings.company_name || "",
      product_descrp: settings.product_descrp || "",
      settings,
      metrics,
      type: settings.is_drug ? "Drug" : "Device",
      total_journals: metrics?.Unique_PMID_Count ?? "—",
      search_terms: Object.entries(perTerm).map(([term, data]) => ({
        term,
        claims_relevant_articles: data?.claims_relevant_articles ?? "—",
      })),
    });
  }

  return Array.from(byFolder.values());
}

export function getSelectedStudyProductName(selectedStudy) {
  if (!selectedStudy) return "";
  if (typeof selectedStudy === "string") return selectedStudy;

  return (
    selectedStudy.product_name ||
    selectedStudy.study_folder_name ||
    selectedStudy.folder ||
    selectedStudy.name ||
    ""
  );
}
